




import app from "@/app";
import BaseComponent from "@/components/BaseComponent.vue";
import { Component } from "vue-property-decorator";

@Component
export default class WAccountEditPass extends BaseComponent {
	done() {
		app.router.goBack();
	}
}
